import { useState } from 'react';

import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData';
import { useHostedValidationsFormAnalytics } from '@percent/hosted-validation-form/hooks/useHostedValidationsFormAnalytics/useHostedValidationsFormAnalytics';

import { SelectOrganisation } from './SelectOrganisation';
import { ClientResponse } from '@percent/hosted-validation-form/api/types/types';
import { GetOrganisationsConfiguration } from '../../HostedForm.types';
import { useQuery } from '@percent/hosted-validation-form/hooks/useQuery/useQuery';
import { ORGANISATION_SEARCH_MIN_LENGTH } from '@percent/hosted-validation-form/ui';

const ORGANISATION_SEARCH_PAGE_SIZE = 25;

export const SelectOrganisationContainer = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { country } = useValidationStepData();
  const { track } = useHostedValidationsFormAnalytics();

  const {
    data: organisationsData,
    isError: isOrganisationsError,
    isLoading: isOrganisationsLoading,
  } = useQuery<
    Record<string, unknown>,
    ClientResponse<GetOrganisationsConfiguration>,
    unknown,
    ClientResponse<GetOrganisationsConfiguration>
  >(
    ['organisations', searchQuery, country],
    (args) => ({
      endpoint: 'v1/organisations',
      args: {
        query: searchQuery,
        countryCode: country,
        pageSize: ORGANISATION_SEARCH_PAGE_SIZE,
        ...(args || {}),
      },
    }),
    {
      retry: false,
      enabled: searchQuery.trim().length >= ORGANISATION_SEARCH_MIN_LENGTH,
      onSuccess: (data) => {
        track('Organisation Search Performed', {
          searchTerm: searchQuery,
          searchResultsCount: Number(data?.data?.totalResults) || 0,
          country,
        });
      },
    },
  );

  return (
    <SelectOrganisation
      data={organisationsData}
      isLoading={isOrganisationsLoading}
      setSearchQuery={setSearchQuery}
      isError={isOrganisationsError}
      country={country}
    />
  );
};
